"use client";

import { useRouter } from "next/navigation";
import { useAuth } from "@workos-inc/authkit-nextjs/components";
import { ArrowRight } from "@/components/icons";
import { Button } from "@/components/ui/button";
import {
  buildInventoryCreateUrl,
  buildInventorySignUpUrl,
} from "@/lib/auth/inventory-create-flow";
import { navigateToDocument } from "@/lib/document-navigation";

interface TradeBottomCtaProps {
  intent: "sell" | "recycle";
  productSlug: string;
  pluralName: string;
}

export function TradeBottomCta({
  intent,
  productSlug,
  pluralName,
}: TradeBottomCtaProps) {
  const router = useRouter();
  const { user } = useAuth();

  const heading =
    intent === "sell"
      ? `Ready to Sell Your ${pluralName}?`
      : `Ready to Recycle Your ${pluralName}?`;

  const handleClick = () => {
    const flowOptions = { productSlug, intent };

    if (user) {
      router.push(buildInventoryCreateUrl(flowOptions));
      return;
    }

    navigateToDocument(buildInventorySignUpUrl(flowOptions));
  };

  return (
    <section className="border-y border-border bg-muted">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left">
          <h2 className="text-lg font-bold text-foreground">{heading}</h2>
          <Button variant="primary" size="default" onClick={handleClick}>
            Get Started
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}
